import { HttpResponse } from '@johnlewispartnership/wtr-website-api-client';

const getCorrelationIdFromResponse = <T>(response: HttpResponse<T>): string | undefined =>
  response.headers?.['wtr-correlation-id'] ?? response.headers?.['x-amzn-requestid'];

export default getCorrelationIdFromResponse;
